import { formatDistanceToNow } from 'date-fns';

export function formatTimestamp(iso) {
    const d = new Date(iso);
    return {
        relative: formatDistanceToNow(d, { addSuffix: true }),
        time: d.toLocaleTimeString(undefined, { hour12: false }),
        full: d.toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'long' }),
        tzLabel: new Intl.DateTimeFormat(undefined, { timeZoneName: 'short' })
            .formatToParts(d)
            .find((p) => p.type === 'timeZoneName').value,
        iso: d.toISOString(),
    };
}
